import { Navigate } from 'react-router'
import { useMyMemberships } from '../gym/useMyMemberships'

/**
 * Keeps a child's own login off a page that is the parent's business.
 *
 * Joining a gym is where its documents are signed, and a child never signs
 * them: the parent does, as the member. The server refuses the request too;
 * this only spares the child a form they cannot submit.
 *
 * The same goes for an account that signed up with the address a parent
 * invited and lost the invite link on the way: it is a child's, it only has
 * not been linked yet, and `/` tells it to go back to the email.
 *
 * Everyone else, signed in or not, gets the page exactly as before.
 */
export function NotForChildAccount({ children }: { children: React.ReactNode }) {
  const { childAccount, pendingChildInvite } = useMyMemberships()
  // To the profile, not to `/`: a child with no active plan has no gym, and `/`
  // sends a member with no gym to Our gyms, which would bounce straight back.
  if (childAccount) return <Navigate to="/profile" replace />
  if (pendingChildInvite) return <Navigate to="/" replace />
  return <>{children}</>
}
